module.exports = __webpack_public_path__ + "img/81_Istoria_a_Alexandrului_celui_Mare_din_Machedoniia_Sibiu_1794_foaie_de_titlu.0fd0e9cd.jpg";